import React from 'react';
import './App.css';
import { Header, Layout, Navigation, Drawer, Content } from 'react-mdl';
import { BrowserRouter, Link } from 'react-router-dom';
import Main from './components/Main.js';

function App() {
    return (
        <BrowserRouter>
            <div className="layout">
                <Layout>
                    <Header
                        title={
                            <Link className="brand-link" to="/">
                                Joseph Johney
                            </Link>
                        }
                        className="header-color"
                        scroll
                    >
                        <Navigation>
                            <Link to="/resume">Resume</Link>
                            <Link to="/projects">Projects</Link>
                            <Link to="/contacts">Contact</Link>
                        </Navigation>
                    </Header>
                    <Drawer
                        title={
                            <Link className="brand-link brand-link-drawer" to="/">
                                Joseph Johney
                            </Link>
                        }
                        className="header-color"
                        scroll
                    >
                        <Navigation>
                            <Link to="/resume">Resume</Link>
                            <Link to="/projects">Projects</Link>
                            <Link to="/contacts">Contact</Link>
                        </Navigation>
                    </Drawer>
                    <Content>
                        <Main />
                    </Content>
                </Layout>
            </div>
        </BrowserRouter>
    );
}

export default App;
